export const CONTRACT_AWAIT_THRESHOLD = 3000;
export const POLLING_TIMEOUT = 250;
export const ORDER_CONFIRMING_NOTIFICATION_DELAY = 1_500; // Show "Confirming..." only if order takes > 1.5s
export const ONCHAIN_TX_RECEIPT_TIMEOUT_MS = 30_000;
export const ORDER_BACKSTOP_TIMEOUT_MS = 30_000;

export const TOAST_DURATION_OPTIONS = {
  fast: 3_000,
  medium: 5_500,
  slow: 8_000,
} as const;

export type ToastDurationOption = keyof typeof TOAST_DURATION_OPTIONS;
export const DEFAULT_TOAST_DURATION: ToastDurationOption = 'medium';

type ToastDurationChoice = { value: ToastDurationOption; label: string };
export const TOAST_DURATION_CHOICES: Readonly<ToastDurationChoice[]> = [
  { value: 'fast', label: `Fast (${TOAST_DURATION_OPTIONS.fast / 1000}s)` },
  { value: 'medium', label: `Medium` },
  { value: 'slow', label: `Slow (${TOAST_DURATION_OPTIONS.slow / 1000}s)` },
];

export const TOAST_LIFETIME = TOAST_DURATION_OPTIONS[DEFAULT_TOAST_DURATION];
export const ANIMATION_TIMEOUT = 250;
export const FUNDING_INTERVAL_SEC = 3600;
export const FUNDING_INTERVAL_BLOCKS = 8571;
export const FOOTER_TICKER_INTERVAL = 1_000;
export const PING_PONG_INTERVAL = 180_000;
export const AUTH_PAYLOAD_TTL = 15 * 60_000;
